import { createSelector } from 'reselect';
import { getAllsureInsurance } from './index';
import { FORM_STATUS } from '../../reducers/status';
import { getApplicationData, getQuoteData, getQuoteTotalAmountMonthly } from './referenceData';
import { getBooleanValue, getContentDetailsObject, getGlobalPaymentFrequency, getHomeDetailsList, getHomeDetailsObject } from './homeDetails';
import { getIsInsurenceTypeSelected } from './insuranceType';
import { getHomeContentList } from './homeContents';
import { getPersonalDetailsForm } from './personalDetails';

export const getMotorDetails = createSelector(getAllsureInsurance, (allsureInsurance) => allsureInsurance.motorDetails);
export const getMotorDetailsForm = createSelector(getMotorDetails, (motorDetails) => motorDetails.form);
export const getEditMotorDetailsKey=createSelector(getMotorDetails,(motorDetails)=>motorDetails.editMotorDetailsKey)
export const getAllMotorDetailForms = createSelector(
    getMotorDetails,
    (allsureInsurance) => allsureInsurance.motorDetailForms
);

export const getInsurenceTypeSelected = (insuranceType) =>
    createSelector(
        getMotorDetailsForm,
        (motorDetailsForm) => motorDetailsForm.motorInsuranceType.value === insuranceType
    );
export const getIsMotorDetailsFormValid = createSelector(
    getMotorDetails,
    (motorDetails) => motorDetails.formStatus === FORM_STATUS.VALID
);

export const getMotorFieldsToBeValidated = createSelector(getMotorDetailsForm, (motorDetailsForm) => {
    const { vehicleModel, vehicleMake, lossSuffered,insuredWithOM } = motorDetailsForm;
    const motorDetails = { ...motorDetailsForm };
    if (vehicleModel?.value !== 'OTHER') delete motorDetails.mentionedVehicleModel;
    if (vehicleMake?.value !== 'OTHER') delete motorDetails.mentionedVehicleMake;

    if (lossSuffered.value !== '01') {
        delete motorDetails.claimAmount;
        delete motorDetails.claimedCount;
    }
    if(insuredWithOM.displayValue<1){
      delete motorDetails.policyNumber;
    }
    return motorDetails;
});
export const getMotorDetailsReferenceData = createSelector(
    getApplicationData,
    ({ vehicleMakeData, vehicleModelData }) => ({
        vehicleMakeReferenceData: Object.values(vehicleMakeData)?.map((make)=>({ value: make, label: make })),
        vehicleModelReferenceData: [...Object.values(vehicleModelData)?.map((make)=>({ value: make, label: make })),...(Object.values(vehicleModelData)?.includes("OTHER")?[]:[{value:"OTHER",label:"OTHER"}])],
        maritalStatusReferenceData: [
            { value: 'married', label: 'Married' },
            { value: 'single', label: 'Single' },
            { value: 'livingTogether', label: 'Living Together' },
            { value: 'widow', label: 'Widow' },
            { value: 'divorced', label: 'Divorced' },
            { value: 'widower', label: 'Widower' },
        ],
        genderReferenceData: [
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' },
        ],
        licenceCodeReferenceData: [
            { value: 'B', label: 'B' },
            { value: 'C', label: 'C' },
            { value: 'C1', label: 'C1' },
            { value: 'EB', label: 'EB' },
            { value: 'EC', label: 'EC' },
            { value: 'EC1', label: 'EC1' },
        ],
        yesNoReferenceData: [
            { value: '01', label: 'Yes' },
            { value: '02', label: 'No' },
        ],
        fuelTypeReferenceData: [
            { value: '01', label: 'Petrol' },
            { value: '02', label: 'Diesel' },
        ],
        vehicleUseReferenceData: [
            { value: '01', label: 'Domestic' },
            { value: '02', label: 'Business' },
        ],
        vehicleTypeReferenceData:[
            { value: '01', label: 'Sedan' },
            { value: '02', label: 'SUV' },  
            { value: '03', label: 'Coupe' },  
        ]
    })
);

export const getMotorDetailsObject = createSelector(getMotorDetails,getGlobalPaymentFrequency, (motorDetails,paymentFrequency) => {
    return motorDetails?.motorDetailForms?.map(
        ({
            vehicleMake,
            vehicleLocation,
            motorInsuranceType,
            vehicleModel,
            vehicleYear,
            trackingDevice,
            isImported,
            fuelType,
            lossSuffered,
            vehicleUse,
            engineCapacity,
            dateOfBirth,
            gender,
            dateOfLicence,
            maritalStatus,
            licenceCode,
            vehicleSumAssured,
            claimedCount,
            claimAmount,
            mentionedVehicleMake,
            mentionedVehicleModel,
            premiumPaid,
            insuredDetails,
            insuredWithOM,
            policyNumber,
            // preferPremium 
            
        }) => {
            const motorDetails = [
                { label: 'Cover type *', value: motorInsuranceType.displayValue ?? '-' },
                { label: 'Vehicle location *', value: vehicleLocation.value ?? '-' },
                { label: 'Vehicle make *', value: vehicleMake.displayValue ==='OTHER'? mentionedVehicleMake?.value : vehicleMake.displayValue },
                { label: 'Vehicle model *', value: vehicleModel.displayValue ==='OTHER' ? mentionedVehicleModel.value: vehicleModel.value },
                { label: 'Vehicle year *', value: vehicleYear.displayValue ?? '-' },
                {
                    label: 'Is the vehicle fitted with a tracking and recovery device? *',
                    value: trackingDevice.displayValue ?? '-',
                },
                { label: 'Is the vehicle imported? *', value: isImported.displayValue ?? '-' },
                { label: 'Is the vehicle diesel or petrol driven? *', value: fuelType.displayValue ?? '-' },
                { label: 'Have you suffered any loss in the last 5 years? *', value: lossSuffered.displayValue ?? '-' },
                { label: 'How many times have you claimed in the last 5 years? *', value: claimedCount.value ?? '-' },
                { label: 'Enter the total value of the claim(s) paid out. (In P)*', value:claimAmount.value === null ? '-' : ("P"+claimAmount.value) },
                { label: 'What is the vehicle used for? *', value: vehicleUse.displayValue ?? '-' },
              //   {
              //     label: 'How many years of uninterrupted insurance cover have you had for your vehicle?',
              //     value: insuredDetails.displayValue ?? '-',
              // },
              // { label: 'How long you have been insured with Old mutual?', value: insuredWithOM.displayValue ?? '-' },
              // ...(insuredWithOM?.value>0 ? [{ label: 'Policy number', value: policyNumber?.value ?? '-' }]:[]),
                { label: 'Engine capacity (CC) *', value: engineCapacity.displayValue ?? '-' },
                { label: 'Date of birth of the regular driver *', value: dateOfBirth.displayValue ?? '-' },
                { label: 'Gender of the regular driver *', value: gender.displayValue ?? '-' },
                {
                    label: "On which year did the regular driver obtain his/her driver’s licence? *",
                    value: dateOfLicence.displayValue ?? '-',
                },
                { label: "Select the regular driver's licence class *", value: licenceCode.displayValue ?? '-' },
                { label: 'Marital status of the regular driver *', value: maritalStatus.displayValue ?? '-' },
                { label: "How often would you like to pay your premium? *", value: paymentFrequency ?? '-' },
                // { label: `Preferred premium amount per ${ premiumPaid?.value}`,value: preferPremium?.displayValue ?? '-'},
                { label: 'Vehicle sum insured (In P) *', value:vehicleSumAssured.displayValue === null ? '-' : ("P"+vehicleSumAssured.displayValue)},
            ];
            lossSuffered.value === '02' && motorDetails.splice(9, 2);
            return motorDetails;
        }
    );
});
export const filterdValueNegotiateMotor=createSelector(getMotorDetails,(motorDetails)=>motorDetails.motorDetailForms.map(motorItem=>motorItem.preferPremium))
export const getMotorDetailsNegociateObject = createSelector(getMotorDetails, (motorDetails) => {
    return motorDetails?.motorDetailForms?.map(
        ({
            vehicleMake,
            vehicleLocation,
            motorInsuranceType,
            vehicleModel,
            vehicleYear,
            trackingDevice,
            isImported,
            fuelType,
            lossSuffered,
            vehicleUse,
            engineCapacity,
            dateOfBirth,
            gender,
            dateOfLicence,
            maritalStatus,
            licenceCode,
            vehicleSumAssured,
            claimedCount,
            claimAmount,
            mentionedVehicleMake,
            mentionedVehicleModel,
            premiumPaid,
            insuredDetails,
            insuredWithOM,
            policyNumber
        }) => {
            const motorDetails = [
                { label: 'Cover type *', value: motorInsuranceType.displayValue ?? '-' },
                // { label: 'Vehicle location *', value: vehicleLocation.value ?? '-' },
                { label: 'Vehicle make *', value: vehicleMake.displayValue ==='OTHER'? mentionedVehicleMake?.value : vehicleMake.displayValue },
                { label: 'Vehicle model *', value: vehicleModel.displayValue ==='OTHER' ? mentionedVehicleModel.value: vehicleModel.value },
                // { label: 'Vehicle year *', value: vehicleYear.displayValue ?? '-' },
                // {
                //     label: 'Is the vehicle fitted with a tracking and recovery device? *',
                //     value: trackingDevice.displayValue ?? '-',
                // },
                // { label: 'Is the vehicle imported? *', value: isImported.displayValue ?? '-' },
                // { label: 'Is the vehicle diesel or petrol driven? *', value: fuelType.displayValue ?? '-' },
                // { label: 'Have you suffered any loss in the last 5 years? *', value: lossSuffered.displayValue ?? '-' },
                // { label: 'How many times have you claimed in the last 5 years? *', value: claimedCount.value ?? '-' },
                // { label: 'Enter the total value of the claim(s) paid out. *', value: "P"+claimAmount.value ?? '-' },
                // { label: 'What is the vehicle used for? *', value: vehicleUse.displayValue ?? '-' },
                // { label: 'Engine capacity (CC) *', value: engineCapacity.displayValue ?? '-' },
                // { label: 'Date of birth of the regular driver *', value: dateOfBirth.displayValue ?? '-' },
                // { label: 'Gender of the regular driver *', value: gender.displayValue ?? '-' },
                // {
                //     label: "On which year did the regular driver obtain his/her driver’s licence? *",
                //     value: dateOfLicence.displayValue ?? '-',
                // },
                // { label: "Select the regular driver's licence class *", value: licenceCode.displayValue ?? '-' },
                // { label: 'Marital status of the regular driver *', value: maritalStatus.displayValue ?? '-' },
                // { label: "How often would you like to pay your premium? *", value: premiumPaid.value ?? '-' },
                { label: 'Vehicle sum insured (In P) *', value: "P"+vehicleSumAssured.displayValue ?? '-' },
            ];
            lossSuffered.value === '02' && motorDetails.splice(9, 2);
            return motorDetails;
        }
    );
});

const isMotorCoverSelected = createSelector(getHomeContentList,getHomeDetailsList,(homeContent,homeDetails)=>homeContent.length || homeDetails.length)


const defaultFields=[
    {label:"Excess",value:"500"},
]

export const getCallMeBackPayload =(usermail)=> createSelector(
    getHomeDetailsObject,
    getContentDetailsObject,
    getMotorDetailsObject,
    getIsInsurenceTypeSelected('homeOwners'),
    getIsInsurenceTypeSelected('homeContent'),
    getIsInsurenceTypeSelected('motor'),
    (homeDetails, homeContentDetails, motorDetails,isHomeOwners,isHomeContent,isMotor) => {
        const homeMaped = isHomeOwners? homeDetails?.map((item, index) => ({ title: ` Home Details ${index?(index + 1):''}`, data: [...item,...usermail?[]:defaultFields] })):[];
        const homeContentMaped = isHomeContent ? homeContentDetails?.map((item, index) => ({
            title: ` Home Contents Details ${index?(index + 1):''}`,
            data: [...item,...usermail?[]:defaultFields],
        })):[];
        const motorMaped = isMotor? motorDetails?.map((item, index) => ({ title: ` Motor Details  ${index?(index + 1):''}`, data: item })):[];
        return {homeMaped,homeContentMaped,motorMaped}
    }
);

export const getEstimatedPremiumBreakdown = createSelector(
  getQuoteData,
  (quoteData) => {
    const premiums = {
      'Homeowners Premium': [],
      'Home Contents Premium': [],
      'Motor Premium': []
    };
    quoteData?.homeQuotes?.forEach((item) => {
      if (item.homeOwnersMonthlyPremium) {
        premiums['Homeowners Premium'].push({ value: item.homeOwnersMonthlyPremium });
      }
      if (item.homeContentMonthlyPremium) {
        premiums['Home Contents Premium'].push({ value: item.homeContentMonthlyPremium });
      }
    });
    quoteData?.motorQuotes?.forEach((item) => {
      if (item.motorMonthlyPremium) {
        premiums['Motor Premium'].push({ value: item.motorMonthlyPremium });
      }
    });
    return Object.entries(premiums).flatMap(([baseLabel, entries]) =>
      entries.length > 1
        ? entries.map((e, i) => ({ label: `${baseLabel} ${i + 1}`, value: e.value }))
        : entries.map((e) => ({ label: baseLabel, value: e.value }))
    );
  }
);
export const getNegotiatedPremiumBreakdown = createSelector(
  [getHomeDetailsList, getHomeContentList, getAllMotorDetailForms],
  (homeDetailsList, homeContentList, motorDetailsList) => {
    const premiums = {
      'Homeowners Premium': [],
      'Home Contents Premium': [],
      'Motor Premium': []
    };
    homeDetailsList?.forEach((item) => {
      if (item?.preferPremium) {
        premiums['Homeowners Premium'].push({ value: {...item.preferPremium ,value:+item.preferPremium.value} });
      }
    });
    homeContentList?.forEach((item) => {
      if (item?.preferPremium) {
        premiums['Home Contents Premium'].push({ value: {...item.preferPremium ,value:+item.preferPremium.value} });
      }
    });
    motorDetailsList?.forEach((item) => {
      if (item?.preferPremium) {
        premiums['Motor Premium'].push({ value: {...item.preferPremium ,value:+item.preferPremium.value} });
      }
    });
    return Object.entries(premiums).flatMap(([baseLabel, entries]) =>
      entries.length > 1
        ? entries.map((e, i) => ({ label: `${baseLabel} ${i + 1}`, value: e.value }))
        : entries.map((e) => ({ label: baseLabel, value: e.value }))
    );
  }
);
export const getQuoteSummaryProductLabel = createSelector(
    getHomeDetailsList,
    getHomeContentList,
    getAllMotorDetailForms,
    (homeOwners,homeContent,motor)=>{
      if(homeOwners?.length && homeContent?.length && motor?.length){
        return 'Are you ready to buy Home contents, Homeowners, and Motor insurance?'
      } else if(homeContent?.length && motor?.length){
        return 'Are you ready to buy this Home contents & Motor insurance?'
      }else if(homeOwners?.length && motor?.length){
        return 'Are you ready to buy this Homeowners & Motor insurance?'
      } else if(homeContent?.length && homeOwners?.length){
        return 'Are you ready to buy this Homeowners & Home contents insurance?'
      } else if(homeOwners?.length){
        return 'Are you ready to buy this Homeowners insurance?'
      } else if(homeContent?.length){
        return 'Are you ready to buy this Home contents insurance?'
      } else if(motor?.length){
        return 'Are you ready to buy this Motor insurance?'
      } else {
        return 'Are you ready to buy this insurance?'
      }
    }
  )

  export const getEmailSubjectLabel = createSelector(
    getHomeDetailsList,
    getHomeContentList,
    getAllMotorDetailForms,
    (homeOwners,homeContent,motor)=>{
      if(homeOwners?.length && homeContent?.length && motor?.length){
        return 'Home contents, Homeowners, and Motor insurance'
      } else if(homeContent?.length && motor?.length){
        return 'Home contents & Motor insurance'
      }else if(homeOwners?.length && motor?.length){
        return 'Homeowners & Motor insurance'
      } else if(homeContent?.length && homeOwners?.length){
        return 'Homeowners & Home contents insurance'
      }else if(homeOwners?.length){
        return 'Homeowners insurance'
      } else if(homeContent?.length){
        return 'Home contents insurance'
      } else if (motor?.length){
        return 'Motor insurance'
      } else {
        return 'This insurance'
      }
    }
  )
export const getTotalPreferredPremium = createSelector(
  getHomeDetailsList,
  getHomeContentList,
  getAllMotorDetailForms,
  (homeDetails, homeContentDetails, motorDetails) => {
    const allDetails = [...homeDetails, ...homeContentDetails, ...motorDetails];
    const total = allDetails.reduce((total, detail) => {
      const value = detail?.preferPremium?.value;
      const num = typeof value === 'string' ? Number(value) : NaN;
      return !isNaN(num) ? total + num : total;
    }, 0);
    return total;
  }
);

